(function() {
    'use strict';
    angular.module('app')
        .controller('OfficeBySpendController', function($scope, $routeParams, ReportingOfficeBySpendTableDataService, $location) {
            $scope.params = $routeParams;
            $scope.OfficeBySpendTableData = new ReportingOfficeBySpendTableDataService({
                companyId: $scope.params.companyId
            }).tableData;
            $scope.goTo = goTo;
            $scope.companyName = $scope.params.companyName;
            $scope.companyId = $scope.params.companyId;

            function goTo(path, params){
            	$location.path(path).search(params);
            }
        });
})();



// WEBPACK FOOTER //
// ./js/controllers/reporting/OfficeBySpendController.js